export class DateFilter {
    value: Date | string;
    condition = "ge";
}
